import { render } from "./iap-chip.vue?vue&type=template&id=157ac628&scoped=true&ts=true"
import script from "./iap-chip.vue?vue&type=script&lang=ts"
export * from "./iap-chip.vue?vue&type=script&lang=ts"

import "./iap-chip.vue?vue&type=style&index=0&id=157ac628&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-157ac628"]])

export default __exports__